import { Alert, Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DetailPanelContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  marginTop: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  overflow: "hidden",
}));

export const DetailPanelBody = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  padding: theme.spacing(2),
}));

export const DetailPanelCustomerAccessSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
});

export const DetailPanelHeader = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const DetailPanelSuccessAlertContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  marginBottom: theme.spacing(2),
}));

export const DetailPanelFooter = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

export const DetailPanelInlineAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  flexShrink: 0,
}));

export const DetailPanelPlatformRoleSection = styled(Box)({
  flexShrink: 0,
});

export const DetailPanelEmptyStateText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
}));
